import { render } from "./SmartSliderHeadingMenu.vue?vue&type=template&id=274cfb7c&scoped=true"
import script from "./SmartSliderHeadingMenu.vue?vue&type=script&lang=js"
export * from "./SmartSliderHeadingMenu.vue?vue&type=script&lang=js"

import "./SmartSliderHeadingMenu.vue?vue&type=style&index=0&id=274cfb7c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-274cfb7c"]])

export default __exports__